const PARAMETERS_MOCK = [
  {
    default: "string no specification default",
    description: "string no specification description",
    name: "string-no-specification",
    type: "string",
  },
  {
    default: "string null specification default",
    description: "string null specification description",
    name: "string-null-specification",
    type: "string",
    specification: null,
  },
  {
    default: "string no regexp default",
    description: "string no regexp description",
    name: "string-no-regexp",
    type: "string",
    specification: {},
  },
  {
    default: "string null regexp default",
    description: "string null regexp description",
    name: "string-null-regexp",
    type: "string",
    specification: {regexp: null},
  },
  {
    default: "bbc*",
    description: "string with regexp description",
    name: "string-with-regexp",
    type: "string",
    specification: {regexp: "^a*b+[cd]\\*"},
  },
  {
    default: "https://www.url.com",
    description: "url description",
    name: "url",
    type: "url",
  },
  {
    default: 0,
    description: "float null specification description",
    name: "float-null-specification",
    type: "float",
    specification: null,
  },
  {
    default: 0.0,
    description: "float empty specification description",
    name: "float-empty-specification",
    type: "float",
    specification: {},
  },
  {
    default: 10,
    description: "float min specification description",
    name: "float-min-specification",
    type: "float",
    specification: {min: 5},
  },
  {
    default: 0.5,
    description: "float max specification description",
    name: "float-max-specification",
    type: "float",
    specification: {max: 5},
  },
  {
    default: 1499,
    description: "float min-max specification description",
    name: "float-min-max-specification",
    type: "float",
    specification: {min: -1.5e3, max: 1.5e3},
  },
  {
    default: 0,
    description: "integer null specification description",
    name: "integer-null-specification",
    type: "integer",
    specification: null,
  },
  {
    default: 0,
    description: "integer min-max specification description",
    name: "integer-min-max-specification",
    type: "integer",
    specification: {min: -1500, max: 1500},
  },
  {
    default: true,
    description: "boolean description",
    name: "boolean",
    type: "boolean",
  },
  {
    default: "value2",
    description: "enum description",
    name: "enum",
    type: "enum",
    specification: {values: ["value1", "value2", "value3"]},
  },
  {
    description: "file no spec description",
    name: "file-no-spec",
    type: "file",
  },
  {
    description: "file with spec description",
    name: "file-with-spec",
    type: "file",
    specification: {mime_types: "image/*, .pdf"},
  },
]


editSubBotBoxController.$inject = ['$scope', 
                                    '$mdDialog',
                                    '$translate',
                                    'QuickRepliesFactory',
                                    'ApplicationsFactory',
                                    'AlertingFactory',
                                    'elementData',
                                    'context'];
export function editSubBotBoxController($scope, 
                                        $mdDialog,
                                        $translate,
                                        QuickRepliesFactory,
                                        ApplicationsFactory,
                                        AlertingFactory,
                                        elementData,
                                        context) {


  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.loadExternalDescription = loadExternalDescription;
  $scope.hasInputVariables = hasInputVariables;
  $scope.hasOutputVariables = hasOutputVariables;
  $scope.fileParam = {'isValid': true};

  let subBotNameBeforeEdition;

  init();


  function ok() {
    if (subBotNameBeforeEdition !== elementData.subBotDescription.name) {
      elementData.exits = elementData.subBotDescription.exits; // SubBoxView will use this property to update the exits, and then delete it
    }
    $mdDialog.hide({type: 'ok', data: elementData});
  }


  function cancel() {
    $mdDialog.cancel();
  }


  function loadExternalDescription() {
    $scope.loading = true;
    QuickRepliesFactory.getSubBotExternalDescription(context.companyId, context.site.id, elementData.externalDescriptionURL)
      .then(response => { 
        QuickRepliesFactory.forwardExternalSubbotDescription( context.companyId, context.site.id, response.data.description, 
                                                              elementData.externalDescriptionURL, elementData.client_app_id);
        setSubBotDescriptionAndResetParameters(response.data.description);
      }, AlertingFactory.httpErrorHandler())
      .finally(() => $scope.loading = false); 
  }


  function setSubBotDescriptionAndResetParameters(description) {
    elementData.subBotDescription = description;
    elementData.parameters = {};
    description.parameters.forEach(param => elementData.parameters[param.name] = param.default);
    $scope.hasSubBotDescription = true;
    $scope.applicationId = elementData.client_app_id;
    $scope.externalDescriptionURL = elementData.externalDescriptionURL;
  }

  function clearParameters() {
    elementData.parameters = {};
  }

  function onModeChanged(newValue) {
    clearParameters();
    $scope.hasSubBotDescription = false;
    if (newValue === 'internal' && $scope.internalSubBotName) {
      const internalDescription = $scope.subBotDescriptions.find(description => description.name === $scope.internalSubBotName.value);
      if (internalDescription) {
        setSubBotDescriptionAndResetParameters(internalDescription);
      }
    }
  }


  function initModeDropdownItems() {
    $scope.internalOrExternalDropdownItems = [{
      id: 'internal', 
      label: $translate.instant('parameters/quick_replies/details/graph/edit_subbotbox_internal_option')
    },{
      id: 'external', 
      label: $translate.instant('parameters/quick_replies/details/graph/edit_subbotbox_external_option')
    }];
  }

  function initWithInternalClasses(descriptions) {
    // descriptions[0].parameters = PARAMETERS_MOCK;
    $scope.subBotDescriptions = descriptions;
    $scope.internalClassesDropdownItems = $scope.subBotDescriptions.map(
      description => ({
        id: description.name,
        label: description.description,
        sortKey: description.description
      }));
    if (   elementData.mode === 'internal'
        && (   !elementData.subBotDescription
            || !$scope.subBotDescriptions.map(description => description.name).includes(elementData.subBotDescription.name))) {
      
      setSubBotDescriptionAndResetParameters($scope.subBotDescriptions[0]);
    }
    $scope.internalSubBotName = {
      value: (elementData.subBotDescription && elementData.mode === 'internal') 
              ? elementData.subBotDescription.name 
                  : $scope.subBotDescriptions[0].name
    };
    $scope.hasSubBotDescription = true;
    $scope.$watch('internalSubBotName.value', (newValue, oldValue) => {
      if (newValue != oldValue) {
        const newDescription = $scope.subBotDescriptions.find(description => description.name === $scope.internalSubBotName.value);
        setSubBotDescriptionAndResetParameters(newDescription);
      }
    });
  }

  function initSubbotClientApplicationList(subbotClientApplicationList) {
    $scope.subbotClientApplicationList = subbotClientApplicationList;
    $scope.subbotClientApplicationsDropdownItems = $scope.subbotClientApplicationList.map(
      app => ({
        id: app.id,
        label: app.name,
        sortKey: app.name
      }));
  }

  function hasInputVariables() {
    return elementData.subBotDescription.input_variables.length > 0;
  }

  function hasOutputVariables() {
    return elementData.subBotDescription.output_variables.length > 0;
  }

  function init() {
    initModeDropdownItems();
    $scope.elementData = elementData;
    $scope.applicationId = null;
    $scope.externalDescriptionURL = null;
    $scope.showSpinner = {value: false}; // we pass an object https://stackoverflow.com/questions/54520066/angularjs-parent-ng-model-is-not-binding-with-custom-directive-when-using-ng-if
    if (!elementData.mode) {
      elementData.mode = 'internal';
    }
    if (elementData.subBotDescription) {
      subBotNameBeforeEdition = elementData.subBotDescription.name;
    }
    $scope.hasSubBotDescription = false;
    $scope.loading = true;
    QuickRepliesFactory.getSubBotClasses(context.companyId, context.site.id)
      .then(response => initWithInternalClasses(response.data.descriptions), 
            AlertingFactory.httpErrorHandler())
      .finally(() => $scope.loading = false);

    ApplicationsFactory.getSubbotClientApplicationList(context.companyId)
      .then(response => initSubbotClientApplicationList(response.data),
            AlertingFactory.httpErrorHandler()); 


    $scope.$watch('elementData.mode', (newValue, oldValue) => {
      if (newValue != oldValue) {
        onModeChanged(newValue);
      }
    });
  }

}
